"use client";

import { c as _c } from "react/compiler-runtime";
import { Columns03 } from "@untitledui/icons";
import { useState } from "react";
import { Heading } from "react-aria-components";
import { Dialog, Modal, ModalOverlay } from "@/components/application/modals/modal";
import { Button } from "@/components/base/buttons/button";
import { CloseButton } from "@/components/base/buttons/close-button";
import { Checkbox } from "@/components/base/checkbox/checkbox";
import { DEFAULT_HIDDEN_COLUMN_IDS, pickerColumns, pickerLabel } from "./column-visibility";
export function ColumnsDialog(t0) {
  const $ = _c(25);
  const {
    hiddenColumnIds,
    saveStatus,
    onChange,
    onReset
  } = t0;
  const [open, setOpen] = useState(false);
  let t1;
  if ($[0] !== hiddenColumnIds) {
    t1 = new Set(hiddenColumnIds);
    $[0] = hiddenColumnIds;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const hidden = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Button color="secondary" size="sm" iconLeading={Columns03} aria-label="Columns" onClick={() => setOpen(true)}><span className="hidden sm:inline">Columns</span></Button>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Heading slot="title" className="text-md font-semibold text-pretty text-text-primary">Visible Columns</Heading>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== saveStatus) {
    t4 = saveStatus ? <p className="sr-only" aria-live="polite">{saveStatus}</p> : null;
    $[4] = saveStatus;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = <div className="min-w-0">{t3}{t4}</div>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <CloseButton onClick={() => setOpen(false)} />;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t5) {
    t7 = <div className="flex items-start justify-between gap-3 border-b border-border-secondary px-5 py-4">{t5}{t6}</div>;
    $[9] = t5;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== hidden || $[12] !== onChange) {
    t8 = pickerColumns(true).map(column => <Checkbox key={column.id} size="sm" label={pickerLabel(column)} isSelected={!hidden.has(column.id)} onChange={visible => onChange(column.id, visible)} />);
    $[11] = hidden;
    $[12] = onChange;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t8) {
    t9 = <div className="min-h-0 flex-1 overflow-y-auto overscroll-contain px-5 py-4"><div className="grid grid-cols-1 gap-2 sm:grid-cols-2">{t8}</div></div>;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== onReset) {
    t10 = <div className="flex items-center justify-end border-t border-border-secondary px-5 py-3"><Button color="secondary" size="sm" onClick={() => {
        onReset();
      }}>Reset to Defaults</Button></div>;
    $[16] = onReset;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10 || $[19] !== t7 || $[20] !== t9) {
    t11 = <Modal className="max-w-lg"><Dialog className="w-full"><div className="flex max-h-[min(80dvh,640px)] w-full flex-col overflow-hidden rounded-xl bg-primary shadow-xl ring-1 ring-secondary">{t7}{t9}{t10}</div></Dialog></Modal>;
    $[18] = t10;
    $[19] = t7;
    $[20] = t9;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== open || $[23] !== t11) {
    t12 = <>{t2}<ModalOverlay isOpen={open} onOpenChange={setOpen} isDismissable={true} className="overscroll-contain">{t11}</ModalOverlay></>;
    $[22] = open;
    $[23] = t11;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  return t12;
}
export const columnsDialogDefaultHidden = DEFAULT_HIDDEN_COLUMN_IDS;